import PagarAnexoService from "@/services/PagarAnexoService";

export const pagarAnexo = {
  namespaced: true,
  state: {
    pagarAnexo: {},
  },
  actions: {
    getPagarAnexo({ commit }, payload) {
      return PagarAnexoService.GetPagarAnexo(payload).then(
        (pagarAnexo) => {
          return Promise.resolve(pagarAnexo);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postPagarAnexo({ commit }, payload) {
      return PagarAnexoService.PostPagarAnexo(payload).then(
        (pagarAnexo) => {
          return Promise.resolve(pagarAnexo);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putPagarAnexo({ commit }, payload) {
      return PagarAnexoService.PutPagarAnexo(payload).then(
        (pagarAnexo) => {
          return Promise.resolve(pagarAnexo);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deletePagarAnexo({ commit }, payload) {
      return PagarAnexoService.DeletePagarAnexo(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getPagarAnexoOData({ commit }, payload) {
      return PagarAnexoService.GetPagarAnexoOData(payload).then(
        (pagarAnexo) => {
          return Promise.resolve(pagarAnexo);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default pagarAnexo;
